import { useEffect, useState } from 'react';

/** Rail сворачивается в иконки при ширине < 1280 px (docs/06 §5.7). */
const RAIL_COLLAPSE_QUERY = '(max-width: 1279px)';

export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() =>
    typeof window === 'undefined' ? false : window.matchMedia(query).matches,
  );

  useEffect(() => {
    const list = window.matchMedia(query);
    const onChange = (event: MediaQueryListEvent): void => setMatches(event.matches);
    setMatches(list.matches);
    list.addEventListener('change', onChange);
    return () => list.removeEventListener('change', onChange);
  }, [query]);

  return matches;
}

export function useIsNarrowViewport(): boolean {
  return useMediaQuery(RAIL_COLLAPSE_QUERY);
}
